import React from 'react';
import { Pressable } from 'react-native';
import Colors from '../constants/Colors';

export default function Link({ children, style }: { children: any; style?: any }) {
  return (
    <Pressable
      style={(state) => [state.hovered
        && { backgroundColor: Colors.light.hereworksPrimaryGrey300 }, style]}
    >
      {children}
    </Pressable>
  );
}
